import { supabase } from "@/integrations/supabase/client";
import { useQueryClient } from "@tanstack/react-query";
import { useToast } from "@/hooks/use-toast";

export const usePolicyAcquisitionOperations = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  const createPolicyAcquisition = async (formData: { name: string; description: string }) => {
    try {
      const { error } = await supabase
        .from("policy_acquisition_types")
        .insert([formData]);

      if (error) throw error;

      await queryClient.invalidateQueries({ queryKey: ["policyAcquisitionTypes"] });
      toast({
        title: "Success",
        description: "Policy acquisition type created successfully",
      });
      return true;
    } catch (error) {
      console.error("Error:", error);
      toast({
        title: "Error",
        description: "Failed to create policy acquisition type",
        variant: "destructive",
      });
      return false;
    }
  };

  const updatePolicyAcquisition = async (id: string, formData: { name: string; description: string }) => {
    try {
      const { error } = await supabase
        .from("policy_acquisition_types")
        .update(formData)
        .eq("id", id);

      if (error) throw error;

      await queryClient.invalidateQueries({ queryKey: ["policyAcquisitionTypes"] });
      toast({
        title: "Success",
        description: "Policy acquisition type updated successfully",
      });
      return true;
    } catch (error) {
      console.error("Error:", error);
      toast({
        title: "Error",
        description: "Failed to update policy acquisition type",
        variant: "destructive",
      });
      return false;
    }
  };

  const deletePolicyAcquisition = async (id: string) => {
    try {
      const { error } = await supabase
        .from("policy_acquisition_types")
        .delete()
        .eq("id", id);

      if (error) throw error;

      await queryClient.invalidateQueries({ queryKey: ["policyAcquisitionTypes"] });
      toast({
        title: "Success",
        description: "Policy acquisition type deleted successfully",
      });
      return true;
    } catch (error) {
      console.error("Error:", error);
      toast({
        title: "Error",
        description: "Failed to delete policy acquisition type",
        variant: "destructive",
      });
      return false;
    }
  };

  return {
    createPolicyAcquisition,
    updatePolicyAcquisition,
    deletePolicyAcquisition,
  };
};